/**
 * Created BY HMSPL 
 * Last Last Modified By Balaji on 10/10/2018
 * Last Modified Description : Added Comment
 */
import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SignInComponent } from './sign-in/sign-in.component';
//import { NoAuthRouteGuard } from './../api-services/utils/noAuthRoutegaurd';
import { PoDetailsComponent } from './po-details/po-details.component';

export const SessionRoutes: Routes = [{
  path: '',
  children: [{
    path: 'dealer',
    component: SignInComponent,
   // canActivate: [NoAuthRouteGuard]
  },
  {
    path: 'digitalfactory',
    component: SignInComponent,
   // canActivate: [NoAuthRouteGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
{
  path: 'purchaseorderconfirmpage',
  component: PoDetailsComponent
}]
}];
